import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CategoryHeader from "../../../Components/Headers/CategoryHeader";
import HealthInsuranceForm from "../../../HealthInsurance/CreateQuote/HealthInsuranceForm";
import createInitialValue from "../../../Utilities/InitialValuesSetup/createInitialValue";
import { Form, Formik, FieldArray, useFormikContext } from "formik";
import automaticValidationSchema from "../../../Utilities/ValidationSchemaSetup/automaticValidationSchema";
import * as Yup from "yup";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import CreateQuoteMainObjectView from "../../../HealthInsurance/CreateQuote/CreateQuoteMainObjectView";
import FormSecondaryGenRef from "./FormSecondaryGenRef";
import { useContext } from "react";
import FormPrimaryGenRef from "./FormPrimaryGenRef";


function GenerateRefId(props) {
  const { decryptedResponseId, decryptedProductRef ,isCKYCVerified,setParentNext,kyc_configId,ckycId,a_id} = props;

 
  // useEffect(()=>{
  //   let number = 123242;
  //   dispatch({type:'set_ckyc_number',payload: number});
  // },[]);
  const onSubmit = (data) => {
    // Do something with the next handler
  
    console.log("Submit Data", data);
  };

  return (
    <div>
    <div>
            {!isCKYCVerified ? (
              <FormSecondaryGenRef
              setParentNext = {setParentNext}
              kyc_configId={kyc_configId}
              a_id={a_id}
              decryptedResponseId = {decryptedResponseId}
              // onSubmit = {onSubmit}
            />
            
            ) : (
              <FormPrimaryGenRef 
              ckycId = {ckycId}
              a_id={a_id}
              decryptedResponseId = {decryptedResponseId}
              setParentNext = {setParentNext}/>
            )}
          </div>
          
       
    </div>
  );
}

export default GenerateRefId;
